var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M14.9999 8.83326L11.6666 5.49993M2.08325 18.4166L4.90356 18.1032C5.24813 18.0649 5.42042 18.0458 5.58146 17.9937C5.72433 17.9474 5.86029 17.8821 5.98566 17.7994C6.12696 17.7062 6.24954 17.5836 6.49469 17.3385L17.4999 6.33326C18.4204 5.41279 18.4204 3.9204 17.4999 2.99993C16.5795 2.07945 15.0871 2.07945 14.1666 2.99992L3.16136 14.0052C2.91621 14.2503 2.79363 14.3729 2.70045 14.5142C2.61778 14.6396 2.55243 14.7755 2.50618 14.9184C2.45405 15.0794 2.43491 15.2517 2.39662 15.5963L2.08325 18.4166Z",
    stroke: "#344054",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.2a91cc809aa0ef3fe1769e655eae3a42.svg";
export { ForwardRef as ReactComponent };